import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import { getOtherRefSearchDropdown } from "../../../api/keyvalue";
import { Icon, Label } from "semantic-ui-react";

const CustomerConsigneeForm = forwardRef(
  ({ errors, isLoading, currentValues, editMode }, ref) => {
    const [customerConsigneeData, setCustomerConsigneeData] = useState(
      editMode
        ? {
            ccoCustomer: "",
            ccoCustomerName: "",
            ccoConsignee: {},
            ccoStatus: 2,
            ccoActive: 1,
          }
        : {
            ccoCode: "",
            ccoReferance: "",
            ccoCustomer: "",
            ccoConsignee: {},
            ccoDiscription: "",
            ccoStatus: 2,
            ccoActive: 1,
          },
    );
    const [customerFieldReset, setCustomerFieldReset] = useState(false);
    const [consigneeFieldReset, setConsigneeFieldReset] = useState(false);
    const [currentErrors, setCurrentErrors] = useState(errors);

    console.log("customerConsigneeData", customerConsigneeData);

    useEffect(() => {
      (async () => {
        if (editMode && currentValues) {
          setCustomerConsigneeData(currentValues);
        }
      })();
    }, [editMode, currentValues]);

    const resetForm = () => {
      setCustomerConsigneeData(
        editMode
          ? {
              ccoCustomer: "",
              ccoCustomerName: "",
              ccoConsignee: {},
              ccoStatus: 2,
              ccoActive: 1,
            }
          : {
              ccoCode: "",
              ccoReferance: "",
              ccoCustomer: "",
              ccoConsignee: {},
              ccoDiscription: "",
              ccoStatus: 2,
              ccoActive: 1,
            },
      );
      setCustomerFieldReset(true);
      setConsigneeFieldReset(true);
    };

    useImperativeHandle(ref, () => ({
      getData: () => customerConsigneeData,
      resetForm: () => resetForm(),
    }));

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <div className="ui dividing header">Customer Consignee</div>
              <div
                style={{
                  display: "flex",
                  //   width: "100%",
                  //   justifyContent: "center",
                  //   alignItems: "center",
                  flexDirection: "column",
                  //   gap: "10px",
                  //   padding: "5px",
                }}
              >
                <div className="two fields">
                  <SearchDropdown
                    key={1}
                    required={true}
                    threshold={1}
                    editMode={editMode}
                    multiGrid={true}
                    multiGridCurrentValue={customerConsigneeData.ccoCustomerName}
                    reset={customerFieldReset}
                    //   multiValues={customerConsigneeObj}
                    setReset={setCustomerFieldReset}
                    onResultSelect={(data) =>
                      setCustomerConsigneeData((prevState) => ({
                        ...prevState,
                        ccoCustomer: data,
                      }))
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "customer",
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_stakeholder",
                      primaryKey: "stk_id",
                      fieldName: "stk_name",
                      id: customerConsigneeData.ccoCustomer,
                    }}
                    // error={currentErrors.ccoCustomer}
                    // resetError={() =>
                    //   setCurrentErrors((prevState) => {
                    //     const { ccoCustomer: _, ...rest } = prevState;
                    //     return rest;
                    //   })
                    // }
                    disabled={editMode}
                    label="Customer"
                  />

                  <SearchDropdown
                    key={1}
                    editMode={editMode}
                    reset={consigneeFieldReset}
                    setReset={setConsigneeFieldReset}
                    //   value={singleConsignee?.rcoConsignee}
                    // error={currentErrors.ccoConsignee}
                    // resetError={() =>
                    //   setCurrentErrors((prevState) => {
                    //     const { ccoConsignee: _, ...rest } = prevState;
                    //     return rest;
                    //   })
                    // }
                    returnFullObject={true}
                    multiValueTwoWayBinding={true}
                    hideMultiValueList={true}
                    multiple={true}
                    multiValues={customerConsigneeData.ccoConsignee}
                    field="cco_consignee"
                    checkCount={true}
                    clearable={false}
                    onClear={() => {
                      setCustomerConsigneeData((prevState) => ({
                        ...prevState,
                        ccoConsignee: {},
                      }));
                    }}
                    onResultSelect={(data) => {
                      console.log("consignee data", data);
                      const key = parseInt(data.key);
                      if (!customerConsigneeData.ccoConsignee[key]) {
                        setCustomerConsigneeData((prevState) => ({
                          ...prevState,
                          ccoConsignee: {
                            ...prevState.ccoConsignee,
                            [key]: data.title,
                          },
                        }));

                        setConsigneeFieldReset(true);
                      }
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Consignee",
                    }}
                    label="Consignees"
                  />
                </div>

                <div
                  className="ui padded segment"
                  style={{ width: "100%", height: "100px", overflow: "auto" }}
                >
                  {Object.keys(customerConsigneeData.ccoConsignee).length ===
                  0 ? (
                    <div
                      className="ui grey header"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      No Cosignees Added
                    </div>
                  ) : (
                    <>
                      {Object.entries(customerConsigneeData.ccoConsignee).map(
                        ([key, value]) => (
                          <Label as="a" style={{ marginBottom: "10px" }}>
                            {value}
                            <Icon
                              name="delete"
                              onClick={() => {
                                const currentKey = parseInt(key);
                                console.log("currentKey", currentKey);

                                //filter both key value pair from ccoConsignees object
                                const filteredConsignees = Object.entries(
                                  customerConsigneeData.ccoConsignee,
                                ).filter(
                                  ([key, value]) =>
                                    parseInt(key) !== currentKey,
                                );

                                setCustomerConsigneeData((prevState) => ({
                                  ...prevState,
                                  ccoConsignee:
                                    Object.fromEntries(filteredConsignees),
                                }));
                              }}
                            />
                          </Label>
                        ),
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
                gap: "5px",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
              <Button
                template="addOrSave"
                //   create={Object.keys(currentCustomerShipper).length === 0}
                //   onClick={onAddClick}
                isLoading={isAddLoading}
              />
            </div> */}
          </form>
        )}
      </>
    );
  },
);

export default CustomerConsigneeForm;
